const EditFileManager = () => {
  return <div>EditFileManager</div>;
};

export default EditFileManager;
